// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "dirty": false,
    "raw": "7fa5c4d",
    "hash": "7fa5c4d",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "7fa5c4d",
    "semverString": null,
    "version": "2.2504.0008"
};
/* tslint:enable */
